import type { FC } from 'react';
import { useState, useEffect } from 'react';
import { SelectInput } from '@interstate/components/SelectInput';
import { Skeleton } from '@interstate/components/Skeleton';
import { useDealershipPicker } from '../hooks/useDealershipPicker';
import { DEALERSHIP_PLACEHOLDER } from '../constants';
import type { DealershipPickerProps } from '../types/DealershipPickerProps';
import { DealershipPickerMode } from '@makemydeal/dr-shared-types';

const DealershipPicker: FC<DealershipPickerProps> = ({
    label = '',
    onChangeDealership,
    value,
    disabled,
    mode = DealershipPickerMode.DEFAULT
}) => {
    const { dealerships, isLoading, shouldDisableSelector, selectedDealership } = useDealershipPicker(mode);
    const [isInitialSelectionUsed, setIsInitialSelectionUsed] = useState(false);

    useEffect(() => {
        if (selectedDealership && !isInitialSelectionUsed) {
            onChangeDealership({ target: { value: selectedDealership } });
            setIsInitialSelectionUsed(true);
        }
    }, [selectedDealership, isInitialSelectionUsed, onChangeDealership]);

    if (isLoading) {
        return (
            <Skeleton
                data-testid="skeleton"
                variant={{
                    type: 'text'
                }}
                sx={{
                    height: '44px'
                }}
            />
        );
    }

    return (
        <SelectInput
            options={dealerships}
            placeholder={DEALERSHIP_PLACEHOLDER}
            onChange={onChangeDealership}
            label={label}
            disabled={disabled || shouldDisableSelector}
            value={value || selectedDealership}
            displayDeselectOption={false}
            data-testid="dealership-picker"
        />
    );
};

export default DealershipPicker;
